<div class="auction-item-notification" [class.mobile]="isMobile">
  <div class="auction-item-notification__top">
    <h4>{{getStatusMsg()}}</h4>
    <p>{{auctionItem.NotificationMessages}}</p>
  </div>
  <div class="auction-item-notification__btm">
    <button type="button" (click)="confirm(true)">Got It</button>
  </div>
</div>